<template>
  <div class="room-categories-filter">
    <e-input v-model="filter.query" label="Поиск">
      <template #append-inner>
        <e-icon name="search" :size="20" />
      </template>
    </e-input>

    <e-select v-model="filter.type" :items="props.types" item-title="name" label="Тип" return-object clearable />
  </div>
</template>

<script setup lang="ts">
import type { RoomInfoType } from '@/parts/room-categories/types';
import { EIcon, EInput, ESelect } from '@/core/components/ui';

const props = defineProps<{
  types: RoomInfoType[];
}>();

const filter = defineModel<{
  query: string;
  type: RoomInfoType | null;
}>({ required: true });
</script>

<style scoped lang="scss">
.room-categories-filter {
  display: grid;

  grid-gap: $gap-4;

  @include sm {
    grid-template-columns: repeat(2, 1fr);
  }

  @include md-and-up {
    grid-template-columns: repeat(2, 280px);
  }
}
</style>
